export const industrySpotlights = [
  // {
  //   title: 'Finance',
  //   description: 'The finance sector is rapidly adopting AI for fraud detection, risk management, and customer experience enhancement.',
  //   image: '/assets/Rectangle 4504.png'
  // },
  // {
  //   title: 'Healthcare',
  //   description: 'AI-powered solutions are transforming healthcare, from personalized treatments to predictive analytics.',
  //   image: '/assets/Rectangle 4505.png'
  // },
  // {
  //   title: 'Logistics',
  //   description: 'AI is revolutionizing logistics, optimizing supply chains, route planning, and delivery systems.',
  //   image: '/assets/Rectangle 4506.png'
  // }

  {
    title: 'Sustainability',
    description: 'Forecast Carbon Emissions trends across continents leveraging AI.',
    image: '/assets/sustainability.webp',
    link: 'https://medium.com/desightsai/case-study-forecasting-carbon-emission-trends-across-continents-with-desights-data-science-6a69e485388b'
  },
  {
    title: 'Cryptocurrency',
    description: 'AI is being used to predict price, risks and other factors in cryptocurrency sector.',
    image: '/assets/crypto.webp',
    link: 'https://medium.com/desightsai/crypto-factor-modeling-driving-innovation-in-cryptocurrency-price-prediction-b524f81e1ea2'
  },
  {
    title: 'Real Estate',
    description: 'Learn how AI can help determine fair price for Real Estate properties.',
    image: '/assets/real-estate.webp',
    link: 'https://medium.com/desightsai/future-proofing-real-estate-how-desights-ai-challenges-drive-predictive-excellence-92ad34dd3858'
  }
]; 